import { apiClient } from '../../lib/api-client';
import type { ChargeRateOption } from './types';

interface ApiResponse<T> { success: true; data: T }

// Reuses the Investigation charge master lookup (name + rate) that already backs Investigation Bill.
export const fetchChargeRates = async (search = ''): Promise<ChargeRateOption[]> => {
  const response = await apiClient.get<ApiResponse<ChargeRateOption[]>>('/investigation-bill/lookups', {
    params: { type: 'charges', ...(search ? { search } : {}), limit: 500 },
  });
  return response.data.data;
};
